import { render, staticRenderFns } from "./SummaryCurrent.vue?vue&type=template&id=3875288b&"
import script from "./SummaryCurrent.vue?vue&type=script&lang=js&"
export * from "./SummaryCurrent.vue?vue&type=script&lang=js&"
import style0 from "./SummaryCurrent.vue?vue&type=style&index=0&id=3875288b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports